import "./App.css";
import User from "./components/User";


const App = () => {
    return (
        <div>
            <User />;
           
        </div>
    );
};

export default App;


    